<template>
  <section class="page-container banner">
    <h3 class="sub-heading">Locations to investigate</h3>
    <div v-for="link in $store.state.currentGame.locations"
      :key="link.name" class="location-card">
      <p class="location-card__title"
        @click="$router.push('/quest')">{{link.name}}</p>
      <hr />
    </div>
    <div class="icon-row">
      <icon-buttons back="back" details="/quest" />
    </div>
  </section>
</template>
<script>
import IconButtons from '@/components/IconButtons.vue';

export default {
  components: {
    IconButtons,
  },
};
</script>
<style lang="scss">
.location-card {
  width: 100%;
}
</style>
